import { baseUrl } from './api.js';

/**
 * Krok UI2 — `/v1/cases/:id/price-range`. Rucni `fetch` (ne `apiClient`):
 * trasa jeste neni v generovanem OpenAPI klientovi a prigenerovani ho
 * (`pnpm --filter @reos/api-client generate`) je samostatny, rizikovy krok
 * (viz pamet "openapi generator nekonci") mimo rozsah teto obrazovky.
 */
export interface MoneyDto {
  readonly amount: string;
  readonly currency: string;
}

export interface NearestListingDto {
  readonly label: string;
  readonly price: MoneyDto;
  readonly url: string | null;
  readonly distanceKm: number;
}

/**
 * Krok CENY2 bod 5 — CELA CENOVA CAST, NE JEN NABIDKY.
 *
 * Radky skladá server (`priceSummaryRows` v `@reos/duediligence`) tymiz texty,
 * jake sazi kapitola „Ceny v okolí" v reportu — obrazovka je jen VYPISUJE
 * a zadnou hodnotu si neformatuje. `note` je puvod („typ ceny · zdroj ·
 * obdobi · metoda") a u KAZDE hodnoty ma byt videt.
 */
export interface MarketPriceRowDto {
  readonly key: string;
  readonly item: string;
  readonly label: string;
  readonly value: string;
  readonly note: string | null;
}

export interface CasePriceRangeDto {
  readonly status: 'ok' | 'insufficient';
  readonly band: { readonly low: MoneyDto; readonly high: MoneyDto } | null;
  readonly median: MoneyDto | null;
  readonly count: number;
  readonly nearest: readonly NearestListingDto[];
  readonly disclaimer: string;
  readonly message: string | null;
  /**
   * Krok CENY2: realizovane ceny, prumer CSU, uredni cena a odhad.
   *
   * NEPOVINNE zamerne — pole pridal az krok CENY2 a pri nasazeni nejde
   * obrazovka a server ve stejne sekunde. Klient proto musi snest i odpoved
   * BEZ nej (chova se jako prazdny vycet), jinak by po nasazeni admina pred
   * api byla karta bila.
   */
  readonly market?: readonly MarketPriceRowDto[] | undefined;
  /** Veta „zadny cenovy udaj nemame"; `null`, kdyz `market` neni prazdne. */
  readonly marketEmpty?: string | null | undefined;
}

async function asJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { title?: string; detail?: string } | null;
    throw new Error(body?.detail ?? body?.title ?? `HTTP ${String(res.status)}`);
  }
  return (await res.json()) as T;
}

export async function getCasePriceRange(caseId: string): Promise<CasePriceRangeDto> {
  const res = await fetch(`${baseUrl}/v1/cases/${encodeURIComponent(caseId)}/price-range`, {
    credentials: 'include',
  });
  return asJson<CasePriceRangeDto>(res);
}

export async function explainCasePriceRange(caseId: string): Promise<{ explanation: string | null }> {
  const res = await fetch(`${baseUrl}/v1/cases/${encodeURIComponent(caseId)}/price-range/explain`, {
    method: 'POST',
    credentials: 'include',
  });
  return asJson<{ explanation: string | null }>(res);
}
